<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title> Личная информация </v-card-title>
          <v-card-title>
            <property-form
              :value="user"
              :fields="
                [
                  'email',
                  'first_name',
                  'last_name',
                  'referral_code',
                  'phone',
                  'inn',
                  'ogrn',
                ].reduce((a, v) => {
                  a[v] = { visible: true };
                  return a;
                }, {})
              "
              @input="doUpdateUser"
            />
          </v-card-title>
        </v-card>
      </v-col>
      <v-col>
        <v-card>
          <v-card-title> Программа для формирования сессий </v-card-title>
          <v-card-subtitle>
            Последняя версия от <b>31/08/2023</b>
          </v-card-subtitle>
          <v-card-text>
            <v-list>
              <v-list-item>
                <a href="/apps-76hyy1ehIa-12/app_1.3.21.09.34.zip">
                  Скачать (Версия от 21.09.2023)
                </a>
              </v-list-item>
              <v-list-item>
                <a href="/api/apps/v1.3.23.08.31">
                  Скачать (Версия от 31.08.2023)
                </a>
              </v-list-item>
              <v-list-item>
                <a href="/api/apps/v1.2.14.08.31">
                  Скачать (Версия от 14.08.2023)
                </a>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PropertyForm from "@/components/PropertyForm.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "AdminPreferenceView",
  components: { PropertyForm },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    ...mapActions(["doUpdateUser"]),
  },
};
</script>

<style scoped></style>
